import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .987,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.20924 1.06075C7.93424 0.97975 8.36324 0.97975 9.14224 1.06075C10.5212 1.26485 11.7995 1.90224 12.7922 2.88075C12.1214 3.51489 11.4593 4.15828 10.8062 4.81075C9.55558 3.75075 8.15958 3.50608 6.61824 4.07675C5.48758 4.59675 4.70024 5.43942 4.25624 6.60475C3.53068 6.06458 2.81457 5.51183 2.10824 4.94675C2.05915 4.92091 2.00309 4.91145 1.94824 4.91975C3.07024 2.75642 4.82358 1.46975 7.20824 1.05975",
			fill: "#F44336"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .997,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.94625 4.92116C2.00292 4.91249 2.05659 4.92149 2.10725 4.94816C2.81358 5.51324 3.52969 6.06599 4.25525 6.60616C4.14108 7.06022 4.0691 7.52385 4.04025 7.99116C4.06492 8.44316 4.13659 8.88682 4.25525 9.32216L2.00025 11.1172C1.01825 9.06516 1.00025 6.99982 1.94625 4.92116Z",
			fill: "#FFC107"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .999,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.6851 13.2907C11.9829 12.6715 11.2479 12.0907 10.4831 11.5507C11.2497 11.0094 11.7151 10.2667 11.8791 9.32272H8.12207V6.71372C10.2887 6.69572 12.4544 6.71405 14.6191 6.76872C15.0297 8.99872 14.5554 11.0094 13.1961 12.8007C13.0344 12.9725 12.8632 13.1361 12.6851 13.2907Z",
			fill: "#448AFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .993,
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.25549 9.32031C5.07549 11.3583 6.57882 12.3096 8.76549 12.1743C9.37932 12.1033 9.96783 11.8888 10.4835 11.5483C11.2488 12.0896 11.9828 12.6696 12.6855 13.2883C11.5721 14.2888 10.1526 14.8824 8.65849 14.9723C8.31903 14.9994 7.97795 14.9994 7.63849 14.9723C5.09315 14.6723 3.21382 13.3863 2.00049 11.1143L4.25549 9.32031Z",
			fill: "#43A047"
		})
	]
});
export default SvgGoogle;
